export default "__VITE_ASSET__C8lR$IUA__"